<!-- svelte-ignore a11y-missing-attribute -->
{#if charity}
  <div class="columns">
    <div class="column is-three-quarters">
      <div class="is-size-4 mb-3">
        <span
          class="is-uppercase is-size-4 has-text-grey-light"
          style="vertical-align:middle;">Charity profile</span>
        <span style="margin-left:20px;display:inline-block;" class="is-size-4">
          <span style="overflow:hidden;">
              <span
                class="tag is-light"
                style="vertical-align: middle;">COMMUNITY BENEFIT SOCIETY</span>&nbsp;
          </span>
        </span>
      </div>
      <hr />

      {#if charity.description}
        <p class="is-size-4">{charity.description}</p>
        <hr />
      {/if}

      <p />
      <div class="columns">
        <div class="column is-one-third">
          <Map postcode={charity.contact.postcode} />
        </div>
        <div class="column">
          <div class="block">
            <p>
              <strong>Website</strong>
            </p>
            <p>
              {#if charity?.website}
                <a href={safeWebsite(charity.website)} target="_blank">{charity.website}</a>
              {:else}
                <p>Not provided</p>
              {/if}
            </p>
          </div>
          <div class="block">
            <p>
              <strong>Registration Number</strong>
            </p>
            <p>
              {info.registrationNumber}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-one-quarter">
      <SocialBar {charity} />
    </div>
  </div>
{/if}

<script lang="ts">
  export let charity :Charity_v2;

  import Map from '../Map.svelte';
  import SocialBar from './SocialBar.svelte';
  import { safeWebsite } from '../../../lib/utils';

  const info = (charity.info as CBS);
</script>
